function helixText(es, en) { return document.documentElement.lang.split("-")[0] === "en" ? en : es; }
function helixRoute(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + path.replace(/^\//, ""); }

/* ── Helix Bio Labs — Theme JS ── */

/* ══ MOBILE MENU ══ */
function helixMobileToggle() {
  const menu = document.getElementById('helix-mobile-menu');
  if (!menu) return;
  menu.classList.toggle('open');
}

/* ══ CART DRAWER ══ */
function helixCartOpen() {
  document.getElementById('helix-cart-overlay')?.classList.add('open');
  document.getElementById('helix-cart-drawer')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function helixCartClose() {
  document.getElementById('helix-cart-overlay')?.classList.remove('open');
  document.getElementById('helix-cart-drawer')?.classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('DOMContentLoaded', function () {
  if (sessionStorage.getItem('helix_reopen_cart') === 'true') {
    sessionStorage.removeItem('helix_reopen_cart');
    helixCartOpen();
    helixShakeConsent();
  }
});
function helixCartUpdate(key, qty) {
  fetch(helixRoute('/cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(() => location.reload());
}
function helixAddToCart(variantId, qty) {
  qty = qty || 1;
  fetch(helixRoute('/cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => r.json())
  .then(() => location.reload())
  .catch(err => console.error('Add to cart error', err));
}

/* ══ TERMS CONSENT GATE ══
   Basic Shopify plans can't edit checkout.liquid, so acceptance has to be
   enforced before checkout (cart page + cart drawer + PDP "Comprar ahora")
   and recorded as a cart attribute so it lands on the order. */
function helixSetTermsAccepted(accepted) {
  HELIX_TERMS_ACCEPTED = accepted;
  document.querySelectorAll('.helix-terms-checkbox').forEach(function (cb) {
    cb.checked = accepted;
  });
  document.querySelectorAll('.helix-checkout-link').forEach(function (el) {
    el.classList.toggle('is-disabled', !accepted);
  });
  var cartBtn = document.getElementById('helix-cart-checkout-btn');
  if (cartBtn) cartBtn.disabled = !accepted;
}

function helixTermsToggle(checkbox) {
  var accepted = checkbox.checked;
  helixSetTermsAccepted(accepted);
  fetch(helixRoute('/cart/update.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { terms_accepted: accepted ? 'yes' : 'no' } })
  }).catch(function (err) { console.error('Terms consent update error', err); });
}

function helixShakeConsent() {
  document.querySelectorAll('.helix-terms-consent').forEach(function (box) {
    box.classList.add('helix-terms-consent--shake');
    setTimeout(function () { box.classList.remove('helix-terms-consent--shake'); }, 500);
  });
}

function helixCheckoutGateClick(e) {
  if (!HELIX_TERMS_ACCEPTED) {
    e.preventDefault();
    helixShakeConsent();
    helixCartOpen();
    return false;
  }
  return true;
}

function helixBuyNowGate(e, variantId) {
  e.preventDefault();
  if (!HELIX_TERMS_ACCEPTED) {
    // Reload (not a redirect) so the cart drawer re-renders server-side with the new item,
    // then auto-reopen it post-reload so the shopper can check the consent box.
    sessionStorage.setItem('helix_reopen_cart', 'true');
    fetch(helixRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function () { location.reload(); })
    .catch(function (err) { console.error('Add to cart error', err); sessionStorage.removeItem('helix_reopen_cart'); });
    return false;
  }
  fetch(helixRoute('/cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function () { window.location.href = helixRoute('/checkout'); })
  .catch(function (err) { console.error('Add to cart error', err); });
  return false;
}

/* ══ SEARCH MODAL ══ */
let helixSearchTimer = null;

function helixSearchOpen() {
  document.getElementById('helix-search-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => document.getElementById('helix-search-input')?.focus(), 100);
}
function helixSearchClose(e) {
  if (e && e.target !== document.getElementById('helix-search-overlay')) return;
  document.getElementById('helix-search-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}
function helixSearchDebounce(q) {
  clearTimeout(helixSearchTimer);
  if (!q.trim()) {
    document.getElementById('helix-search-results').innerHTML =
      '<div style="padding:2rem;text-align:center;color:#9ca3af;font-size:13px;">' + helixText("Escribe para buscar productos...", "Type to search products...") + '</div>';
    return;
  }
  helixSearchTimer = setTimeout(() => helixSearchRun(q), 280);
}
function helixSearchRun(q) {
  const url = helixRoute('/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
  fetch(url)
    .then(r => r.json())
    .then(data => {
      const products = data.resources?.results?.products || [];
      const container = document.getElementById('helix-search-results');
      if (!products.length) {
        container.innerHTML = '<div style="padding:2rem;text-align:center;color:#9ca3af;font-size:13px;">' + helixText("Sin resultados para", "No results for") + ' "' + q + '"</div>';
        return;
      }
      let html = '<div class="helix-search-section-title">' + helixText("Productos", "Products") + '</div>';
      products.forEach(p => {
        const price = p.price ? helixFormatMoney(p.price) : '';
        const img   = p.featured_image?.url ? p.featured_image.url + '&width=96' : '';
        html += `<a href="${p.url}" class="helix-search-product">
          ${img ? `<img class="helix-search-product__img" src="${img}" alt="">` : ''}
          <div>
            <div class="helix-search-product__name">${p.title}</div>
          </div>
          <div class="helix-search-product__price">${price}</div>
        </a>`;
      });
      html += `<a href="${helixRoute('/search')}?q=${encodeURIComponent(q)}" style="display:block;padding:.75rem;text-align:center;font-size:12px;letter-spacing:1px;text-transform:uppercase;color:var(--color-accent);font-weight:600;border-top:1px solid #f3f4f6;margin-top:.5rem;">
        ${helixText("Ver todos los resultados", "View all results")} →
      </a>`;
      container.innerHTML = html;
    });
}
function helixFormatMoney(amount) {
  // /search/suggest.json returns price already as a decimal amount (not cents,
  // unlike the AJAX cart API) — do not divide by 100 here.
  return 'COP ' + Number(amount).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

/* ESC closes search */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    document.getElementById('helix-search-overlay')?.classList.remove('open');
    document.body.style.overflow = '';
  }
});

/* ══ FIRST ORDER POPUP ══ */
const POPUP_KEY = 'helix_popup_v1';

function helixPopupInit() {
  const el = document.getElementById('helix-popup-overlay');
  if (!el) return;
  if (sessionStorage.getItem(POPUP_KEY) || localStorage.getItem(POPUP_KEY)) return;
  const delay = typeof HELIX_POPUP_DELAY === 'number' ? HELIX_POPUP_DELAY : 5000;
  setTimeout(() => {
    el.classList.add('open');
    el.addEventListener('click', function(e) {
      if (e.target === el) helixPopupClose();
    });
  }, delay);
}
function helixPopupClose() {
  document.getElementById('helix-popup-overlay')?.classList.remove('open');
  localStorage.setItem(POPUP_KEY, '1');
}
function helixPopupSubmit() {
  const email = document.getElementById('helix-popup-email')?.value?.trim();
  const whatsapp = document.getElementById('helix-popup-whatsapp')?.value?.trim();
  if (!email && !whatsapp) return;
  if (typeof HELIX_GHL_WEBHOOK === 'string' && HELIX_GHL_WEBHOOK) {
    fetch(HELIX_GHL_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, phone: whatsapp, tags: ['popup-descuento'] })
    }).catch(() => {});
  }
  localStorage.setItem(POPUP_KEY, '1');
  document.getElementById('helix-popup-form').style.display = 'none';
  document.getElementById('helix-popup-success').style.display = 'block';
}
function helixCopyCode() {
  const code = document.getElementById('helix-popup-code')?.textContent?.trim();
  if (!code) return;
  navigator.clipboard.writeText(code).catch(() => {});
}

/* ══ PRODUCT PAGE TABS ══ */
function helixTabSwitch(btn) {
  const pane = btn.dataset.tab;
  document.querySelectorAll('.helix-product__tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.helix-product__tab-pane').forEach(p => p.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById(pane)?.classList.add('active');
}

/* ══ PRODUCT PAGE GALLERY ══ */
function helixGalleryThumb(thumb) {
  const main = document.getElementById('helix-product-main-img');
  if (main) main.src = thumb.src.replace('_100x', '_800x');
  document.querySelectorAll('.helix-product__thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

/* ══ PRODUCT QTY ══ */
function helixQtyChange(delta) {
  const input = document.getElementById('helix-product-qty');
  if (!input) return;
  const val = Math.max(1, parseInt(input.value) + delta);
  input.value = val;
}

/* ══ VARIANT SELECTOR ══ */
function helixVariantSelect(btn, variantId) {
  document.querySelectorAll('.helix-product__variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const addBtn = document.getElementById('helix-add-to-cart-btn');
  if (addBtn) addBtn.dataset.variantId = variantId;
}

/* ══ LANGUAGE SWITCHER ══ */
function helixLangToggle() {
  document.getElementById('helix-lang-menu')?.classList.toggle('open');
}
document.addEventListener('click', function(e) {
  const wrap = document.getElementById('helix-lang-wrap');
  if (wrap && !wrap.contains(e.target)) {
    document.getElementById('helix-lang-menu')?.classList.remove('open');
  }
});

/* ══ INIT ══ */
document.addEventListener('DOMContentLoaded', () => {
  helixPopupInit();
});
